import { ComponentProps } from 'react';
import Image from 'shared/components/Image';

export interface ImageOrientedProps extends ComponentProps<'img'> {}

// Modern browsers support auto-rotating images based on EXIF metadata.
// Most of the latest browsers use `from-image` as the default value,
// but we'll set it here in case some older browsers don't do that by default
export default function ImageOriented(props: ImageOrientedProps) {
  return <Image src={props.src} style={{ imageOrientation: 'from-image' }} alt={props.alt} />;
}
